import React, { useState, useEffect } from 'react';
import axios from 'axios'
import { makeStyles } from '@material-ui/styles';
import { MoneyTypeTable } from './components';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    content: {
        marginTop: theme.spacing(2)
    }
}));

const MoneyTypeData = () => {
    const classes = useStyles();
    const [eslipData, setEslipData] = useState([]);
    const [token] = useState(JSON.parse(localStorage.getItem('token')));
    const url = 'http://localhost:3000/api/eslipData';
    useEffect(() => {
        let source = axios.CancelToken.source();
        const loadData = async () => {
            try {
                const response = await axios.get(url, {
                    headers: {
                        Authorization: 'Bearer ' + token.access_token
                    },
                    cancelToken: source.token
                });
                console.log(response.data)
                console.log("AxiosCancel: got response");
                setEslipData(response);

            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log("AxiosCancel: caught cancel");
                } else {
                    throw error;
                }
            }
        };
        loadData();
    },[])
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <MoneyTypeTable moneytype={eslipData.data} />
            </div>
        </div>
    );
};

export default MoneyTypeData;
